export default {
  namespaced: true,

  state: {
    addresses: [{
      type_address: '',
      type: 1,
      street: '',
      house_number: '',
      city: '',
      postal_code: '',
      country: 'nl',
      floor: 0,
      owner_type: 'private',
      distance: 10,
      move_day: '',
      is_storage: false,
    }, {
      type_address: '',
      type: 2,
      street: '',
      house_number: '',
      city: '',
      postal_code: '',
      country: 'nl',
      floor: 0,
      owner_type: 'private',
      distance: 10,
      move_day: '',
      is_storage: false,
    }],
    addressTemplate: null,
    selectedAddressIndex: 0,
  },

  getters: {
    addresses: (state) => state.addresses,
    addressTemplate: (state) => state.addressTemplate,
    selectedAddressIndex: (state) => state.selectedAddressIndex,
    selectedAddress: (state) => {
      if (typeof state.addresses[state.selectedAddressIndex] === 'undefined') {
        return null;
      }

      return state.addresses[state.selectedAddressIndex];
    },
  },

  actions: {
    //
  },

  mutations: {
    hydrate(state, obj) {
      state.addressTemplate = JSON.parse(obj.addressTemplate);
    },

    setSelectedAddressIndex(state, index) {
      state.selectedAddressIndex = index;
    },

    updateAddressField(state, [selectedAddress, name, value]) {
      selectedAddress[name] = value;
    },

    addAddress(state, type) {
      const { addressTemplate } = state;

      addressTemplate.type = type;
      addressTemplate.country = 'nl';

      state.addresses.push({ ...addressTemplate });

      if (state.addresses.length > 0) {
        state.selectedAddressIndex = state.addresses.length - 1;
        state.selectedAddress = state.addresses[state.selectedAddressIndex];
      }
    },

    removeAddress(state, index) {
      // eslint-disable-next-line no-alert
      if (window.confirm('Weet je zeker dat je dit adres wilt verwijderen?')) {
        state.addresses.splice(index, 1);

        if (state.addresses.length && index === state.selectedAddressIndex) {
          state.selectedAddressIndex = state.addresses.length - 1;
          state.selectedAddress = state.addresses[state.selectedAddressIndex];
        }
      }
    },
  },
};
